<template>
  <v-col
    v-if="(value && value.length) || !!$slots.default"
    class="mb-2"
    v-bind="$attrs"
  >
    <v-card-title v-if="header" class="pl-0 pt-0 pb-1">
      {{ header }}
    </v-card-title>

    <div v-if="label">
      <b class="mr-1" @click="$emit('click:label')" v-text="label + ':'" />
    </div>

    <component :is="wrapperComponent" text>
      <slot>
        <component
          :is="textComponent"
          v-if="typeof value === 'string'"
          v-bind="{ href }"
          @click="$emit('click:value')"
          v-text="value"
        />
        <component
          :is="textComponent"
          v-else-if="Array.isArray(value)"
          v-bind="{ href }"
          @click="$emit('click:value')"
        >
          <template v-if="value.length === 1">
            <span v-text="value[0]" />
          </template>
          <template v-else>
            <ul>
              <li v-for="item in value" :key="String(item)">
                <span v-text="item" />
              </li>
            </ul>
          </template>
        </component>
      </slot>
    </component>
  </v-col>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { VAlert } from 'vuetify/lib';

type Props = {
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  header?: string;
  highlighted?: boolean;
  link?: boolean;
  href?: string;
  hideBulletPoint?: boolean;
};

const props = defineProps<Props>();

defineEmits(['click:label', 'click:value']);

const wrapperComponent = computed(() => (props.highlighted ? VAlert : 'div'));
const textComponent = computed(() => (props.link ? 'a' : 'span'));
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
